import { Label, Dropdown, Card } from '@cimpress/react-components';
import { faDolly } from '@fortawesome/free-solid-svg-icons';
import { faSave } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// tslint:disable-next-line:import-name
import Highlighter from 'react-highlight-words';
import React, { MouseEvent, useMemo } from 'react';
import { useModal } from '../../../contexts/modal-context';
import FontAwesomeTile from '../../utils/FontAwesomeTile';
import PalletBoxList from '../../pallet-boxes/PalletBoxList';
import { ShipmentGroupOptions, ShipmentGroup } from '../../../models/shipment-group';
import ShipmentGroupConfigurationForm from '../../forms/ShipmentGroupConfigurationForm';
import { AlignItems, FlexBox, FlexDirection } from '../../../utils/css-classes';
import { UnsortedShipmentModal } from './UnsortedShipmentsModal';

// tslint:disable-next-line:import-name
import style from './index.module.css';

export interface ShipmentGroupCardProps {
  shipmentGroup: ShipmentGroup;
  highlight?: string;
}

// tslint:disable-next-line:function-name
export function ShipmentGroupCard({ shipmentGroup, highlight }: ShipmentGroupCardProps) {
  const modal = useModal();
  const saveGroup = (e: MouseEvent) => {
    e.preventDefault();
    modal(
      'Create new shipment group',
      hide => <ShipmentGroupConfigurationForm
        shipmentGroupConfiguration={{
          name: shipmentGroup.internalShipmentGroups[0].name,
          option: ShipmentGroupOptions.DEFAULT,
          pinned: false,
          tag: shipmentGroup.tag,
          locationKey: '',
          carrierAccountKeys: [shipmentGroup.internalShipmentGroups[0].key],
        }}
        close={hide}
      />,
    );
  };

  const labels = useMemo(
    () => {
      const results = [
        ...shipmentGroup.internalShipmentGroups.map(({ name }, i) =>
          <span key={i}>
            <Label text={name} type="info" />
            &nbsp;
          </span>,
        ),
      ];
      if (shipmentGroup.tag) {
        results.push(<Label text={shipmentGroup.tag} type="success" key="tag"/>);
      }
      return results;
    },
    [shipmentGroup],
  );

  const header = <div className={style.CardHeader}>
    <h5>
      <Highlighter
        highlightClassName="highlight"
        searchWords={highlight ? [highlight] : []}
        autoEscape={true}
        textToHighlight={shipmentGroup.name}
      />&nbsp;
      {labels}
    </h5>
    {shipmentGroup.pinned &&
      <Dropdown title={<span className="h3" style={{ margin: '0' }}>&#8285;</span>} type="simple">
        <a href="#" onClick={e => saveGroup(e)}>
          <FontAwesomeIcon icon={faSave} /> Save shipment group
        </a>
      </Dropdown>}
  </div>;

  return <Card header={header} isMinimal className={style.Card}>
    <div className={style.CardContent}>
      <FontAwesomeTile
        icon={faDolly}
        className={style.Unsorted}
        label="Unsorted"
        topRightLabel={`${shipmentGroup.shipmentCount}`}
        color="var(--danger)"
        highlight={highlight}
        onClick={
          () => {
            modal(
              <div className={`${FlexBox.FLEX} ${FlexDirection.ROW} ${AlignItems.FLEX_END}`}>
                <span>Unsorted Shipments - {shipmentGroup.name}&nbsp;</span>
                {labels}
              </div>,
              () => <UnsortedShipmentModal shipmentGroup={shipmentGroup} />,
              { bsSize: 'lg', style: { width: '80%' } },
            );
          }
        }
      />
      <PalletBoxList palletBoxes={shipmentGroup.palletBoxes} className={style.PalletBoxes} highlight={highlight}/>
    </div>
  </Card>;
}
